import Mapping from '../mapping/component';

export default class ResourceMapping extends Mapping {
  primaryComponent = 'plugin-config-field/resource';
}
